
import breakTo from '../../styles/tools/breakTo'

export default ({ colors, spacings, fontSizes, fontWeights }) => ({
  iframeMobile:{
    position: 'relative',
    width:"100%",
    height:"500px",
    maxWidth:"51rem!important"
  },
  iframeTablet:{
    position: 'relative',
    width: '100%',
    height: '380px',
    top: '21%',
    marginRight: 'auto',
    marginLeft: 'auto',
    border: 'none'
  },
  overlayTablet:{
    width: '75%',
    height: 'auto',
    position: 'fixed',
    top: '15%',
    right: '11%',
    left: '11%',
    background: 'white',
    zIndex: '102',
  },
  overlay:{
    // width: '782px', //782
    // height: 'auto',
    // position: 'fixed',
    // top: '15%',
    // left: '20%',
    // background: 'white',
    // zIndex: '102'
    //overflowY: '-webkit-paged-x'
    width: '60%',
    height: 'auto',
    position: 'fixed',
    top: '20%',
    left: '20%',
    background: 'white',
    zIndex: '102',
    right: '20%'
},
iframe:{
  position: 'relative',
  width:  '100%',//'782px'
  height:'380px',
  top: '21%',
  marginRight: 'auto',
  marginLeft: 'auto',
  border: 'none'
},
outeroverlay:{
  width: '100%',
  height: '100%',
  position: 'fixed',
  top: '0',
  left: '0',
  background: 'black',
  zIndex: '100',
  opacity: '0.5',
},
otpMessage:{
      paddingLeft:'45px',
      paddingRight:'21px',
}
})




// WEBPACK FOOTER //
// ./components/iframe/styles.js